const mainDomain = "https://kuality-server.onrender.com/";
//const mainDomain = "https://multivendorplatform.onrender.com/api/health";

const sellerDomain = "https://admin-live-6ha6.onrender.com"
const GetAccessToken = () => {
  const user = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : null;
  if (user) return user.token;

  return null;
};

const GetUserId = () => {
  const user = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : null;

  if (user) return user.userId;

  return null;
};

const Config = {
  AxiosConfig: {
    headers: {
      authorization: `${GetAccessToken()}`,
      id: GetUserId(),
    },
  },

  userType: {
    ADMIN: 'admin',
    BUYER: 'buyer',
    SELLER: 'seller',
  },
  domain: mainDomain,
  apiUrlauth: mainDomain + "api" + "auth",
  apiUrl: mainDomain + "api",
  sessionExpiredTime: 15, // in minutes
  idleTime: 15, // in mins
  sellerDomain: sellerDomain,
  
  // Google OAuth configuration
  googleClientId: "1042977887782-5t6su8uh8vbb5aakvgahn9m21s67hj2a.apps.googleusercontent.com", 

  productMapping: {
    1: "Sample 1",
    2: "Sample 2",
    3: "Sample 3",
    4: "Sample 4",
  },

  orderStatus: {
    1: "success",
    2: "dispatched",
    3: "out-for-del",
    4: "reached",
  },

  dueType: {
    RENT: 1,
    MAINTENANCE: 3,
  },
};

export const dueTypes = [
  { value: 3, label: "Maintenance" },
  { value: 4, label: "Electricity" },
  { value: 5, label: "Registration" },
];


export const PaginationLimit = 10;

export const plans = [
  { value: 1, label: "Bronze" },
  { value: 2, label: "Silver" },
  { value: 3, label: "Gold" },
];

export const ForUs = (userId) => {
  if (userId === "abcdefghiojklmndidiekddd") { //need to write correct corresponding id
    return true;
  }

  return false;
};

export const gTypeOfRoles = [
  { value: "1", label: "Registrar" },
  { value: "2", label: "Customers" },
  { value: "3", label: "Subadmins" },
  { value: "4", label: "Reports" },
];

export default Config;
